import React from 'react';
export function BonusSection() {
  return <section className="bg-white py-16 px-4 md:px-8" data-id="element-16">
      <div className="max-w-4xl mx-auto" data-id="element-17">
        <div className="text-center mb-12" data-id="element-18">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-19">
            🎁 BONOS GRATIS HOY
          </h2>
          <p className="text-2xl text-gray-600 font-medium" data-id="element-20">
            Te llevás 2 bonos exclusivos
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-21">
          {/* Bono 1 */}
          <div className="flex flex-col items-center" data-id="element-22">
            <div className="relative w-full max-w-[400px] aspect-square mb-6" data-id="element-23">
              <img src="https://cdn.magicpatterns.com/uploads/g7cN5ucaCXhqmqnbgdt5U6/BONO_1_CIENCIAS_SOCIALES.png" alt="Bono 1 Planificación Anual" className="w-full h-full object-cover rounded-xl shadow-2xl hover:scale-105 transition-transform duration-300 cursor-pointer" onClick={() => document.getElementById('compra')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-24" />
              <div className="absolute top-4 right-4 bg-red-600 text-white font-bold py-1 px-3 rounded-full shadow-lg" data-id="element-25">
                GRATIS
              </div>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center" data-id="element-26">
              BONO 1 – GRATIS
            </h3>
            <h4 className="text-xl font-bold text-green-600 mb-4 text-center" data-id="element-27">
              PLANIFICACIÓN ANUAL LISTA
            </h4>
            <p className="text-gray-700 text-center leading-relaxed" data-id="element-28">
              Organizá todo el año escolar con una planificación clara, simple y
              adaptable, sin estrés y sin empezar de cero.
            </p>
          </div>

          {/* Bono 2 */}
          <div className="flex flex-col items-center" data-id="element-29">
            <div className="relative w-full max-w-[400px] aspect-square mb-6" data-id="element-30">
              <img src="https://cdn.magicpatterns.com/uploads/3Ld2dy3DRbkXxq5BxQcEDP/BONO_2_CIENCIAS_SOCIALES.png" alt="Bono 2 Evaluaciones y Seguimiento" className="w-full h-full object-cover rounded-xl shadow-2xl hover:scale-105 transition-transform duration-300 cursor-pointer" onClick={() => document.getElementById('compra')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-31" />
              <div className="absolute top-4 right-4 bg-red-600 text-white font-bold py-1 px-3 rounded-full shadow-lg" data-id="element-32">
                GRATIS
              </div>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center" data-id="element-33">
              BONO 2 – GRATIS
            </h3>
            <h4 className="text-xl font-bold text-green-600 mb-4 text-center" data-id="element-34">
              Evaluaciones y Seguimiento sin Estrés
            </h4>
            <p className="text-gray-700 text-center leading-relaxed" data-id="element-35">
              Instrumentos simples y claros para evaluar contenidos de historia,
              geografía y ciudadanía sin improvisar ni perder tiempo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}